module.exports = __webpack_public_path__ + "static/stacks-8b2a85ae78a70f6bce8c4f173c9477d4.png";